<style>
    .overflow-hidden { overflow: hidden; }
    .outer { position: relative; left: 50%; float: left; }
    .inner { position: relative; left: -50%; float: left; }
    .hidden {
        display: none;
    }

    .log-table thead th, .log-table tbody td{
        padding: 0 .75rem;
        vertical-align: middle;
        border: none;
    }
    .log-table tr {
        border-top: 1px solid #91ccda;
        padding: 16px;
    }
    .log-table tr:first-child {
        border-top: none;
    }

    .log-table tr:hover {
        background-color: #ebf5f8;
    }

    .log-table tr td {
        color: #223264;
        border: none;
    }

    .log-table tr.BTable-details {
        border-top: 0px;
        border-bottom: solid 1px #91ccda;
    }
    .log-table tr.BTable-details:last-child {
        border-bottom: none;
    }

    .log-table tr.BTable-details:hover,
    .log-table tr.BTable-has-details:hover {
        background-color: transparent;
    }

    .log-table tr td {
        cursor: pointer;
    }
    .log-table tr.BTable-details td {
        cursor: initial;
    }

    #main_content .log-table td p {
        font-size: 16px;
    }

    .smaller-icon-container {
        font-size: .725em;        
    }
</style>

<template>
    <div class="component-container">
        <BTable ref="table"
            :items="orderedLogs" 
            :fields="fields" 
            :current-page="currentPage"
            :per-page="perPage"
            :responsive="true"
            class="log-table"
            :showEmpty="true"
            empty-text="There are no activity logs for this childcare program">
            <template v-slot:cell(type)="row" style="width: 40%">
                <div @click.stop="row.toggleDetails">
                    <strong>{{row.item.type.name}}</strong>
                </div>
            </template>
            <template v-slot:cell(user)="row">
                <div @click.stop="row.toggleDetails">
                    {{row.item.user.first_name}} {{row.item.user.last_name}}
                </div>
            </template>
            <template v-slot:cell(date)="row">
                <div @click.stop="row.toggleDetails">
                    {{ formatDate(row.item.date) }}
                </div>
            </template>
            <template v-slot:cell(show_details)="row">
                <div class="col text-right" @click.stop="row.toggleDetails">
                    <div class="smaller-icon-container" v-show="(!row.item._showDetails)">
                        <span class="fa fa-plus"></span>
                    </div>
                    <div class="smaller-icon-container" v-show="(row.item._showDetails)">
                        <span class="fa fa-minus"></span>
                    </div>
                </div>
            </template>
            <template v-slot:row-details="{item, index}">
                <p>Time Spent: <strong>{{item.time_spent}} minutes</strong></p>
                <p>Areas Covered: <strong>{{item.areaString}}</strong></p>
                <p><p>{{item.notes}}</p></p>
                <button type="button" class="btn btn-orange-blue" v-on:click="$emit('editlogentry', item)">
                    Edit
                </button>
                <br><br>
            </template>

        </BTable>
        <div class="overflow-hidden">
            <div class="outer">
                <BPagination 
                    :total-rows="totalRows" 
                    :per-page="perPage" 
                    v-model="currentPage" 
                    :hide-goto-end-buttons="true" 
                    class="inner"
                />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            logs: {
                required: true,
                type: Array
            }
        },
        data() {
            return {
                perPage: 5,
                currentPage: 1,
                fields: [
                    {
                        key: 'type',
                        thStyle: {
                            width: '40%'
                        },
                        label: ''
                    }, 
                    {
                        key: 'user',
                        thStyle: {
                            width: '20%'
                        },
                        label: ''
                    }, 
                    {
                        key: 'date',
                        thStyle: {
                            width: '20%'
                        },
                        label: ''
                    }, 
                    {
                        key: 'show_details',
                        label: ''
                    }
                ]
            }
        },
        computed: {
            totalRows: function () {
                return this.logs.length
            },
            orderedLogs: function () {
                return this.logs.sort((a,b) => {
                    const aStamp = moment(a.date).unix();
                    const bStamp = moment(b.date).unix();

                    if (aStamp == bStamp) {
                        return 0;
                    } else if (aStamp > bStamp) {
                        return 1;
                    } else {
                        return -1
                    }
                });
            },
            formatDate(dateString, format = 'MM/DD/YY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            }
        },
        mounted() {
            console.log(this.logs);
        }
    }
</script>